module.exports = __webpack_public_path__ + "img/consultoria_3-4_1152.755efdaa.jpg";